import { defineComponent as _defineComponent } from 'vue'
import { type CategoryBannerData } from './CategoryBannerSmall.vue';

interface Props {
  data: CategoryBannerData[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryBannerSmallGroup',
  props: {
    data: null
  },
  setup(__props: any) {



const position = (index: number) => {
  return (index + 1) % 2 ? 1 : 2;
};

return { __sfc: true,position }
}

})